export default "__VITE_ASSET__DGZWSVSI__"